"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9791],{

/***/ 53663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DA": function() { return /* binding */ ActivityLog; }
/* harmony export */ });
/* unused harmony exports MarketCreatedLog, CommentLog */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var common_envs_constants__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(58756);
/* harmony import */ var common_util_array__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(15336);
/* harmony import */ var lodash_keyBy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83864);
/* harmony import */ var lodash_keyBy__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_keyBy__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4215);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38354);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_groupBy__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95099);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27378);
/* harmony import */ var web_hooks_use_bets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63583);
/* harmony import */ var web_hooks_use_comments__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18037);
/* harmony import */ var web_hooks_use_contracts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88176);
/* harmony import */ var web_hooks_use_group__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8974);
/* harmony import */ var web_hooks_use_persistent_state__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52951);
/* harmony import */ var web_hooks_use_user__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56314);
/* harmony import */ var web_lib_firebase_groups__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88331);
/* harmony import */ var _buttons_pill_button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16865);
/* harmony import */ var _contract_contract_mention__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34002);
/* harmony import */ var _feed_feed_bets__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(38011);
/* harmony import */ var _layout_col__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(18264);
/* harmony import */ var _layout_row__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(77990);
/* harmony import */ var _relative_timestamp__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(20568);
/* harmony import */ var _widgets_avatar__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(31818);
/* harmony import */ var _widgets_editor__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(23610);
/* harmony import */ var _widgets_loading_indicator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(33794);
/* harmony import */ var _widgets_user_link__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(19487);

























const EXTRA_USERNAMES_TO_EXCLUDE = [
    "Charlie"
];
function ActivityLog(props) {
    const privateUser = (0,web_hooks_use_user__WEBPACK_IMPORTED_MODULE_11__/* .usePrivateUser */ .MZ)();
    const user = (0,web_hooks_use_user__WEBPACK_IMPORTED_MODULE_11__/* .useUser */ .aF)();
    const memberGroups = (0,web_hooks_use_group__WEBPACK_IMPORTED_MODULE_9__/* .useMemberGroups */ .rc)(user === null || user === void 0 ? void 0 : user.id);
    const shouldBlockDestiny = // If signed out, or you don't follow destiny group, block it!
    !(memberGroups && memberGroups.some((g)=>common_envs_constants__WEBPACK_IMPORTED_MODULE_23__/* .DESTINY_GROUP_SLUGS.includes */ .Ps.includes(g.slug)));
    const [blockedGroupContractIds, setBlockedGroupContractIds] = (0,web_hooks_use_persistent_state__WEBPACK_IMPORTED_MODULE_10__/* .usePersistentState */ .Yw)(undefined, {
        key: "blockedGroupContractIds",
        store: (0,web_hooks_use_persistent_state__WEBPACK_IMPORTED_MODULE_10__/* .inMemoryStore */ .cF)()
    });
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        var ref;
        const blockedGroupSlugs = (0,common_util_array__WEBPACK_IMPORTED_MODULE_24__/* .buildArray */ .f6)((ref = privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedGroupSlugs) !== null && ref !== void 0 ? ref : [], shouldBlockDestiny && common_envs_constants__WEBPACK_IMPORTED_MODULE_23__/* .DESTINY_GROUP_SLUGS */ .Ps);
        Promise.all(blockedGroupSlugs.map(web_lib_firebase_groups__WEBPACK_IMPORTED_MODULE_12__/* .getGroupBySlug */ .UE)).then((groups)=>Promise.all((0,common_util_array__WEBPACK_IMPORTED_MODULE_24__/* .filterDefined */ .d0)(groups).map((g)=>(0,web_lib_firebase_groups__WEBPACK_IMPORTED_MODULE_12__/* .getGroupContractIds */ .NI)(g.id)))).then((cids)=>setBlockedGroupContractIds(cids.flat()));
    }, [
        privateUser,
        setBlockedGroupContractIds,
        shouldBlockDestiny
    ]);
    const blockedContractIds = (0,common_util_array__WEBPACK_IMPORTED_MODULE_24__/* .buildArray */ .f6)(blockedGroupContractIds, privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedContractIds);
    var ref;
    const blockedUserIds = (ref = privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedUserIds) !== null && ref !== void 0 ? ref : [];
    const { count , showPills  } = props;
    const rawBets = (0,web_hooks_use_bets__WEBPACK_IMPORTED_MODULE_6__/* .useLiveBets */ .D4)(count * 3 + 20, {
        filterRedemptions: true,
        filterAntes: true
    });
    const bets = (rawBets !== null && rawBets !== void 0 ? rawBets : []).filter((bet)=>!blockedContractIds.includes(bet.contractId) && !blockedUserIds.includes(bet.userId) && !common_envs_constants__WEBPACK_IMPORTED_MODULE_23__/* .BOT_USERNAMES.includes */ .uB.includes(bet.userUsername) && !EXTRA_USERNAMES_TO_EXCLUDE.includes(bet.userUsername));
    const rawComments = (0,web_hooks_use_comments__WEBPACK_IMPORTED_MODULE_7__/* .useLiveComments */ .VE)(count * 3);
    const comments = (rawComments !== null && rawComments !== void 0 ? rawComments : []).filter((c)=>c.commentType === "contract" && !blockedContractIds.includes(c.contractId) && !blockedUserIds.includes(c.userId) && !common_envs_constants__WEBPACK_IMPORTED_MODULE_23__/* .BOT_USERNAMES.includes */ .uB.includes(c.userUsername));
    const rawContracts = (0,web_hooks_use_contracts__WEBPACK_IMPORTED_MODULE_8__/* .useLiveContracts */ .VP)(count * 3);
    const newContracts = (rawContracts !== null && rawContracts !== void 0 ? rawContracts : []).filter((c)=>!blockedContractIds.includes(c.id) && !blockedUserIds.includes(c.creatorId));
    const [pill, setPill] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("all");
    const items = lodash_sortBy__WEBPACK_IMPORTED_MODULE_4___default()(pill === "all" ? [
        ...bets,
        ...comments,
        ...newContracts !== null && newContracts !== void 0 ? newContracts : []
    ] : pill === "comments" ? comments : pill === "trades" ? bets : newContracts !== null && newContracts !== void 0 ? newContracts : [], (i)=>i.createdTime).reverse().filter((i)=>i.createdTime < Date.now());
    const contracts = (0,common_util_array__WEBPACK_IMPORTED_MODULE_24__/* .filterDefined */ .d0)((0,web_hooks_use_contracts__WEBPACK_IMPORTED_MODULE_8__/* .useContracts */ .GP)([
        ...bets.map((b)=>b.contractId),
        ...comments.map((c)=>c.contractId)
    ])).concat(newContracts !== null && newContracts !== void 0 ? newContracts : []);
    const contractsById = lodash_keyBy__WEBPACK_IMPORTED_MODULE_1___default()(contracts, "id");
    var ref1;
    const startIndex = (ref1 = lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(0, items.length - count).find((i)=>items.slice(i, i + count).every((item)=>"contractId" in item ? contractsById[item.contractId] : true))) !== null && ref1 !== void 0 ? ref1 : 0;
    const itemsSubset = items.slice(startIndex, startIndex + count);
    const allLoaded = rawBets && rawComments && rawContracts && blockedGroupContractIds && itemsSubset.every((item)=>"contractId" in item ? contractsById[item.contractId] : true);
    const groups = Object.entries(lodash_groupBy__WEBPACK_IMPORTED_MODULE_3___default()(itemsSubset, (item)=>"contractId" in item ? item.contractId : item.id)).map((param)=>{
        let [contractId, items] = param;
        return {
            contractId,
            items
        };
    });
    if (!allLoaded) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_widgets_loading_indicator__WEBPACK_IMPORTED_MODULE_21__/* .LoadingIndicator */ .T, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_col__WEBPACK_IMPORTED_MODULE_16__/* .Col */ .J, {
        className: "gap-4",
        children: [
            showPills && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_row__WEBPACK_IMPORTED_MODULE_17__/* .Row */ .X, {
                className: "gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_pill_button__WEBPACK_IMPORTED_MODULE_13__/* .PillButton */ .T, {
                        selected: pill === "all",
                        onSelect: ()=>setPill("all"),
                        children: "All"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_pill_button__WEBPACK_IMPORTED_MODULE_13__/* .PillButton */ .T, {
                        selected: pill === "markets",
                        onSelect: ()=>setPill("markets"),
                        children: "Markets"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_pill_button__WEBPACK_IMPORTED_MODULE_13__/* .PillButton */ .T, {
                        selected: pill === "comments",
                        onSelect: ()=>setPill("comments"),
                        children: "Comments"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_pill_button__WEBPACK_IMPORTED_MODULE_13__/* .PillButton */ .T, {
                        selected: pill === "trades",
                        onSelect: ()=>setPill("trades"),
                        children: "Trades"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_col__WEBPACK_IMPORTED_MODULE_16__/* .Col */ .J, {
                className: "divide-y border",
                children: groups.map((param)=>{
                    let { contractId , items  } = param;
                    const contract = contractsById[contractId];
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_col__WEBPACK_IMPORTED_MODULE_16__/* .Col */ .J, {
                        className: "gap-2 bg-white px-6 py-4 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contract_contract_mention__WEBPACK_IMPORTED_MODULE_14__/* .ContractMention */ .D, {
                                contract: contract
                            }),
                            items.map((item)=>"amount" in item ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_feed_feed_bets__WEBPACK_IMPORTED_MODULE_15__/* .FeedBet */ .D, {
                                    className: "!pt-0",
                                    contract: contract,
                                    bet: item,
                                    avatarSize: "xs"
                                }, item.id) : "question" in item ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MarketCreatedLog, {
                                    contract: item
                                }, item.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommentLog, {
                                    comment: item
                                }, item.id))
                        ]
                    }, contractId);
                })
            })
        ]
    });
}
const MarketCreatedLog = (props)=>{
    const { creatorAvatarUrl , creatorUsername , creatorName , createdTime  } = props.contract;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_row__WEBPACK_IMPORTED_MODULE_17__/* .Row */ .X, {
        className: "items-center gap-2 text-sm text-gray-500",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_widgets_avatar__WEBPACK_IMPORTED_MODULE_19__/* .Avatar */ .q, {
                avatarUrl: creatorAvatarUrl,
                username: creatorUsername,
                size: "xs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_widgets_user_link__WEBPACK_IMPORTED_MODULE_22__/* .UserLink */ .DL, {
                name: creatorName,
                username: creatorUsername
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_row__WEBPACK_IMPORTED_MODULE_17__/* .Row */ .X, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-gray-400",
                        children: "created"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_relative_timestamp__WEBPACK_IMPORTED_MODULE_18__/* .RelativeTimestamp */ .Q, {
                        time: createdTime
                    })
                ]
            })
        ]
    });
};
const CommentLog = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_5__.memo)(function FeedComment(props) {
    const { comment  } = props;
    const { userName , text , content , userUsername , userAvatarUrl , createdTime  } = comment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_col__WEBPACK_IMPORTED_MODULE_16__/* .Col */ .J, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_row__WEBPACK_IMPORTED_MODULE_17__/* .Row */ .X, {
                id: comment.id,
                className: "mb-1 items-center gap-2 text-sm text-gray-500",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_widgets_avatar__WEBPACK_IMPORTED_MODULE_19__/* .Avatar */ .q, {
                        size: "xs",
                        username: userUsername,
                        avatarUrl: userAvatarUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_widgets_user_link__WEBPACK_IMPORTED_MODULE_22__/* .UserLink */ .DL, {
                                name: userName,
                                username: userUsername
                            }),
                            " commented",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_relative_timestamp__WEBPACK_IMPORTED_MODULE_18__/* .RelativeTimestamp */ .Q, {
                                time: createdTime
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_widgets_editor__WEBPACK_IMPORTED_MODULE_20__/* .Content */ .VY, {
                size: "sm",
                className: "grow",
                content: content || text
            })
        ]
    });
});


/***/ }),

/***/ 32047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DailyStats; },
/* harmony export */   "b": function() { return /* binding */ DailyProfit; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38944);
/* harmony import */ var lodash_sum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79424);
/* harmony import */ var lodash_sum__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_sum__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var web_components_layout_col__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18264);
/* harmony import */ var web_hooks_use_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56314);
/* harmony import */ var web_components_layout_row__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77990);
/* harmony import */ var common_util_format__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80093);
/* harmony import */ var web_components_profile_betting_streak_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31339);
/* harmony import */ var web_components_profile_loans_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66463);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);












const dailyStatsHeaderClass = "text-gray-500 text-xs sm:text-sm";
const dailyStatsClass = "items-center text-lg";
function DailyStats(props) {
    var ref;
    const { user , showLoans  } = props;
    const privateUser = (0,web_hooks_use_user__WEBPACK_IMPORTED_MODULE_5__/* .usePrivateUser */ .MZ)();
    var ref1;
    const streaks = (ref1 = privateUser === null || privateUser === void 0 ? void 0 : (ref = privateUser.notificationPreferences) === null || ref === void 0 ? void 0 : ref.betting_streaks) !== null && ref1 !== void 0 ? ref1 : [];
    const streaksHidden = streaks.length === 0;
    const [showLoansModal, setShowLoansModal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const showLoansModel = (next_router__WEBPACK_IMPORTED_MODULE_2___default().query.show) === "loans";
        setShowLoansModal(showLoansModel);
        const showStreaksModal = (next_router__WEBPACK_IMPORTED_MODULE_2___default().query.show) === "betting-streak";
        setShowStreakModal(showStreaksModal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [showStreakModal, setShowStreakModal] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    var ref2, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_row__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
        className: "flex-shrink-0 gap-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DailyProfit, {
                user: user
            }),
            !streaksHidden && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_col__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                className: "cursor-pointer",
                onClick: ()=>setShowStreakModal(true),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: dailyStatsHeaderClass,
                        children: "Streak"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_layout_row__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(dailyStatsClass, user && !(0,web_components_profile_betting_streak_modal__WEBPACK_IMPORTED_MODULE_7__/* .hasCompletedStreakToday */ .h)(user) && "grayscale"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                (ref2 = user === null || user === void 0 ? void 0 : user.currentBettingStreak) !== null && ref2 !== void 0 ? ref2 : 0,
                                "\uD83D\uDD25"
                            ]
                        })
                    })
                ]
            }),
            showLoans && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_col__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                className: "hidden cursor-pointer sm:flex",
                onClick: ()=>setShowLoansModal(true),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: dailyStatsHeaderClass,
                        children: "Next loan"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_layout_row__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(dailyStatsClass, user && !(0,web_components_profile_betting_streak_modal__WEBPACK_IMPORTED_MODULE_7__/* .hasCompletedStreakToday */ .h)(user) && "grayscale"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "text-teal-500",
                            children: [
                                "\uD83C\uDFE6 ",
                                (0,common_util_format__WEBPACK_IMPORTED_MODULE_11__/* .formatMoney */ .lb)((ref3 = user === null || user === void 0 ? void 0 : user.nextLoanCached) !== null && ref3 !== void 0 ? ref3 : 0)
                            ]
                        })
                    })
                ]
            }),
            showLoansModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_profile_loans_modal__WEBPACK_IMPORTED_MODULE_8__/* .LoansModal */ .I, {
                isOpen: showLoansModal,
                setOpen: setShowLoansModal
            }),
            showStreakModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_profile_betting_streak_modal__WEBPACK_IMPORTED_MODULE_7__/* .BettingStreakModal */ .u, {
                isOpen: showStreakModal,
                setOpen: setShowStreakModal,
                currentUser: user
            })
        ]
    });
}
function DailyProfit(props) {
    const { user  } = props;
    const contractMetricsByProfit = (0,web_hooks_use_user__WEBPACK_IMPORTED_MODULE_5__/* .useUserContractMetricsByProfit */ .jz)(user === null || user === void 0 ? void 0 : user.id);
    var ref;
    const profit = lodash_sum__WEBPACK_IMPORTED_MODULE_3___default()((ref = contractMetricsByProfit === null || contractMetricsByProfit === void 0 ? void 0 : contractMetricsByProfit.metrics.map((m)=>m.from ? m.from.day.profit : 0)) !== null && ref !== void 0 ? ref : []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_9___default()), {
        className: "flex flex-col",
        href: "/daily-movers",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: dailyStatsHeaderClass,
                children: "Daily profit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_row__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
                className: dailyStatsClass,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: (0,common_util_format__WEBPACK_IMPORTED_MODULE_11__/* .formatMoney */ .lb)(profit)
                    }),
                    " "
                ]
            })
        ]
    });
}


/***/ }),

/***/ 38011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FeedBet; }
/* harmony export */ });
/* unused harmony export BetStatusText */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var web_hooks_use_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56314);
/* harmony import */ var web_components_layout_row__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77990);
/* harmony import */ var web_components_widgets_avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31818);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38944);
/* harmony import */ var common_util_format__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80093);
/* harmony import */ var web_components_outcome_label__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10606);
/* harmony import */ var web_components_relative_timestamp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20568);
/* harmony import */ var common_pseudo_numeric__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12471);
/* harmony import */ var web_components_widgets_site_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67263);
/* harmony import */ var web_lib_firebase_challenges__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16213);
/* harmony import */ var web_components_widgets_user_link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19487);
/* harmony import */ var common_user__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51403);
/* harmony import */ var common_util_math__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66747);
















const FeedBet = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function FeedBet(props) {
    const { contract , bet , avatarSize , className  } = props;
    const { userAvatarUrl , userUsername , createdTime  } = bet;
    const showUser = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(createdTime).isAfter("2022-06-01");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_row__WEBPACK_IMPORTED_MODULE_4__/* .Row */ .X, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(className, "items-center gap-2 pt-3"),
        children: [
            showUser ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_widgets_avatar__WEBPACK_IMPORTED_MODULE_5__/* .Avatar */ .q, {
                size: avatarSize,
                avatarUrl: userAvatarUrl,
                username: userUsername
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_widgets_avatar__WEBPACK_IMPORTED_MODULE_5__/* .EmptyAvatar */ .P, {
                className: "mx-1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BetStatusText, {
                bet: bet,
                contract: contract,
                hideUser: !showUser,
                className: "flex-1"
            })
        ]
    });
});
function BetStatusText(props) {
    var ref;
    const { bet , contract , hideUser , className  } = props;
    const { outcomeType , mechanism  } = contract;
    const self = (0,web_hooks_use_user__WEBPACK_IMPORTED_MODULE_3__/* .useUser */ .aF)();
    const isFreeResponse = outcomeType === "FREE_RESPONSE";
    const isCPMM2 = mechanism === "cpmm-2";
    const { amount , outcome , createdTime , challengeSlug , shares  } = bet;
    const [challenge, setChallenge] = react__WEBPACK_IMPORTED_MODULE_1__.useState();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (challengeSlug) {
            (0,web_lib_firebase_challenges__WEBPACK_IMPORTED_MODULE_9__/* .getChallenge */ .CD)(challengeSlug, contract.id).then((c)=>{
                setChallenge(c);
            });
        }
    }, [
        challengeSlug,
        contract.id
    ]);
    const bought = amount >= 0 ? "bought" : "sold";
    const isShortSell = isCPMM2 && amount > 0 && shares === 0;
    const money = (0,common_util_format__WEBPACK_IMPORTED_MODULE_12__/* .formatMoney */ .lb)(Math.abs(amount));
    const orderAmount = bet.limitProb !== undefined && bet.orderAmount !== undefined ? (0,common_util_format__WEBPACK_IMPORTED_MODULE_12__/* .formatMoney */ .lb)(bet.orderAmount) : "";
    const anyFilled = !(0,common_util_math__WEBPACK_IMPORTED_MODULE_13__/* .floatingLesserEqual */ .lq)(amount, 0);
    var _orderAmount;
    const allFilled = (0,common_util_math__WEBPACK_IMPORTED_MODULE_13__/* .floatingEqual */ .zx)(amount, (_orderAmount = bet.orderAmount) !== null && _orderAmount !== void 0 ? _orderAmount : amount);
    var ref1;
    const hadPoolMatch = (ref1 = bet.limitProb === undefined || ((ref = bet.fills) === null || ref === void 0 ? void 0 : ref.some((fill)=>fill.matchedBetId === null))) !== null && ref1 !== void 0 ? ref1 : false;
    var _limitProb;
    const fromProb = hadPoolMatch || isFreeResponse ? (0,common_pseudo_numeric__WEBPACK_IMPORTED_MODULE_14__/* .getFormattedMappedValue */ .g7)(contract)(bet.probBefore) : (0,common_pseudo_numeric__WEBPACK_IMPORTED_MODULE_14__/* .getFormattedMappedValue */ .g7)(contract)((_limitProb = bet.limitProb) !== null && _limitProb !== void 0 ? _limitProb : bet.probBefore);
    var _limitProb1;
    const toProb = hadPoolMatch || isFreeResponse ? (0,common_pseudo_numeric__WEBPACK_IMPORTED_MODULE_14__/* .getFormattedMappedValue */ .g7)(contract)(bet.probAfter) : (0,common_pseudo_numeric__WEBPACK_IMPORTED_MODULE_14__/* .getFormattedMappedValue */ .g7)(contract)((_limitProb1 = bet.limitProb) !== null && _limitProb1 !== void 0 ? _limitProb1 : bet.probAfter);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("text-sm text-gray-500", className),
        children: [
            !hideUser ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_widgets_user_link__WEBPACK_IMPORTED_MODULE_10__/* .UserLink */ .DL, {
                name: bet.userName,
                username: bet.userUsername
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: (self === null || self === void 0 ? void 0 : self.id) === bet.userId ? "You" : "A ".concat(common_user__WEBPACK_IMPORTED_MODULE_15__/* .BETTOR */ .af)
            }),
            " ",
            orderAmount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    anyFilled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            "filled limit order ",
                            money,
                            "/",
                            orderAmount
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            "created limit order for ",
                            orderAmount
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_outcome_label__WEBPACK_IMPORTED_MODULE_6__/* .OutcomeLabel */ .se, {
                        outcome: outcome,
                        value: bet.value,
                        contract: contract,
                        truncate: "short"
                    }),
                    " ",
                    "at ",
                    toProb,
                    " ",
                    bet.isCancelled && !allFilled ? "(cancelled)" : ""
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    bought,
                    " ",
                    money,
                    " ",
                    isCPMM2 && (isShortSell ? "NO of " : "YES of"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_outcome_label__WEBPACK_IMPORTED_MODULE_6__/* .OutcomeLabel */ .se, {
                        outcome: outcome,
                        value: bet.value,
                        contract: contract,
                        truncate: "short"
                    }),
                    " ",
                    fromProb === toProb ? "at ".concat(fromProb) : "from ".concat(fromProb, " to ").concat(toProb)
                ]
            }),
            " ",
            challengeSlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_widgets_site_link__WEBPACK_IMPORTED_MODULE_8__/* .SiteLink */ .J, {
                href: challenge ? (0,web_lib_firebase_challenges__WEBPACK_IMPORTED_MODULE_9__/* .getChallengeUrl */ .Sq)(challenge) : "",
                className: "mx-1",
                children: "[challenge]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_relative_timestamp__WEBPACK_IMPORTED_MODULE_7__/* .RelativeTimestamp */ .Q, {
                time: createdTime
            })
        ]
    });
}


/***/ }),

/***/ 31339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ hasCompletedStreakToday; },
/* harmony export */   "u": function() { return /* binding */ BettingStreakModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var web_components_layout_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52155);
/* harmony import */ var web_components_layout_col__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18264);
/* harmony import */ var common_economy__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76765);
/* harmony import */ var common_util_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80093);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38944);







function BettingStreakModal(props) {
    const { isOpen , setOpen , currentUser  } = props;
    const missingStreak = currentUser && !hasCompletedStreakToday(currentUser);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_layout_modal__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u, {
        open: isOpen,
        setOpen: setOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_col__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
            className: "items-center gap-4 rounded-md bg-white px-8 py-6",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("text-8xl", missingStreak ? "grayscale" : "grayscale-0"),
                    children: "\uD83D\uDD25"
                }),
                missingStreak && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_col__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
                    className: " gap-2 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "font-bold",
                            children: "You haven't predicted yet today!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "ml-2",
                            children: "If the fire icon is gray, this means you haven't predicted yet today to get your streak bonus. Get out there and make a prediction!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-xl",
                    children: "Daily prediction streaks"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_col__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-indigo-700",
                            children: "• What are they?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "ml-2",
                            children: [
                                "You get ",
                                (0,common_util_format__WEBPACK_IMPORTED_MODULE_5__/* .formatMoney */ .lb)(common_economy__WEBPACK_IMPORTED_MODULE_6__/* .BETTING_STREAK_BONUS_AMOUNT */ .Rx),
                                " more for each day of consecutive predicting up to",
                                " ",
                                (0,common_util_format__WEBPACK_IMPORTED_MODULE_5__/* .formatMoney */ .lb)(common_economy__WEBPACK_IMPORTED_MODULE_6__/* .BETTING_STREAK_BONUS_MAX */ .vR),
                                ". The more days you predict in a row, the more you earn!"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-indigo-700",
                            children: "• Where can I check my streak?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "ml-2",
                            children: "You can see your current streak on the top right of your profile page."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-indigo-700",
                            children: "• Can I save my streak if I forget?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "ml-2",
                            children: [
                                "You get 1 streak forgiveness per month that prevents your streak from resetting.",
                                currentUser && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    children: [
                                        " ",
                                        "Right now you have",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "mx-1 font-bold",
                                            children: currentUser.streakForgiveness
                                        }),
                                        "left."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function hasCompletedStreakToday(user) {
    const now = dayjs__WEBPACK_IMPORTED_MODULE_3___default()().utc();
    const utcTodayAtResetHour = now.hour(common_economy__WEBPACK_IMPORTED_MODULE_6__/* .BETTING_STREAK_RESET_HOUR */ .xl).minute(0).second(0);
    const utcYesterdayAtResetHour = utcTodayAtResetHour.subtract(1, "day");
    let resetTime = utcTodayAtResetHour.valueOf();
    if (now.isBefore(utcTodayAtResetHour)) {
        resetTime = utcYesterdayAtResetHour.valueOf();
    }
    var ref;
    return ((ref = user === null || user === void 0 ? void 0 : user.lastBetTime) !== null && ref !== void 0 ? ref : 0) > resetTime;
}


/***/ }),

/***/ 66463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ LoansModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var web_components_layout_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52155);
/* harmony import */ var web_components_layout_col__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18264);
/* harmony import */ var common_user__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51403);
/* harmony import */ var common_envs_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58756);





function LoansModal(props) {
    const { isOpen , setOpen  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(web_components_layout_modal__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u, {
        open: isOpen,
        setOpen: setOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_col__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
            className: "items-center gap-4 rounded-md bg-white px-8 py-6",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "text-8xl",
                    children: "\uD83C\uDFE6"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "text-xl",
                    children: [
                        "Daily loans on your ",
                        common_user__WEBPACK_IMPORTED_MODULE_3__/* .PAST_BETS */ .qz
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(web_components_layout_col__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-indigo-700",
                            children: "• What are daily loans?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "ml-2",
                            children: "Every day at midnight PT, get 2% of your total bet amount back as a loan."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-indigo-700",
                            children: "• Do I have to pay back a loan?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "ml-2",
                            children: "Yes, don't worry! You will automatically pay back loans when the market resolves or you sell your bet."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-indigo-700",
                            children: "• What is the purpose of loans?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "ml-2",
                            children: "Loans make it worthwhile to bet on markets that won't resolve for months or years, because your investment won't be locked up as long."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-indigo-700",
                            children: "• What is an example?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "ml-2",
                            children: [
                                "For example, if you bet ",
                                common_envs_constants__WEBPACK_IMPORTED_MODULE_4__/* .ENV_CONFIG.moneyMoniker */ .pg.moneyMoniker,
                                '1000 on "Will I become a millionare?", you will get ',
                                common_envs_constants__WEBPACK_IMPORTED_MODULE_4__/* .ENV_CONFIG.moneyMoniker */ .pg.moneyMoniker,
                                "20 back tomorrow."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "ml-2",
                            children: [
                                "Previous loans count against your total bet amount. So on the next day, you would get back 2% of ",
                                common_envs_constants__WEBPACK_IMPORTED_MODULE_4__/* .ENV_CONFIG.moneyMoniker */ .pg.moneyMoniker,
                                "(1000 - 20) =",
                                common_envs_constants__WEBPACK_IMPORTED_MODULE_4__/* .ENV_CONFIG.moneyMoniker */ .pg.moneyMoniker,
                                "19.6."
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 30339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useGlobalConfig; }
/* harmony export */ });
/* harmony import */ var web_lib_firebase_globalConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18069);
/* harmony import */ var _use_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(710);


const useGlobalConfig = ()=>{
    return (0,_use_store__WEBPACK_IMPORTED_MODULE_1__/* .useStore */ .o)("globalConfig", (_, setConfig)=>(0,web_lib_firebase_globalConfig__WEBPACK_IMPORTED_MODULE_0__/* .listenForGlobalConfig */ .AH)(setConfig));
};


/***/ }),

/***/ 97543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useSaveReferral; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var web_lib_firebase_users__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63130);



const useSaveReferral = (user, options)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const { referrer  } = router.query;
        const referrerOrDefault = referrer || (options === null || options === void 0 ? void 0 : options.defaultReferrerUsername);
        if (!user && router.isReady && referrerOrDefault) {
            (0,web_lib_firebase_users__WEBPACK_IMPORTED_MODULE_2__/* .writeReferralInfo */ .QN)(referrerOrDefault, {
                contractId: options === null || options === void 0 ? void 0 : options.contractId,
                explicitReferrer: referrer,
                groupId: options === null || options === void 0 ? void 0 : options.groupId
            });
        }
    }, [
        user,
        router,
        options
    ]);
};


/***/ }),

/***/ 18069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ listenForGlobalConfig; },
/* harmony export */   "Hl": function() { return /* binding */ updateGlobalConfig; }
/* harmony export */ });
/* unused harmony export getGlobalConfig */
/* harmony import */ var firebase_firestore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25385);
/* harmony import */ var web_lib_firebase_init__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66454);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3326);



const globalConfigCollection = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(web_lib_firebase_init__WEBPACK_IMPORTED_MODULE_1__.db, "globalConfig");
const globalConfigDoc = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .doc */ .JU)(globalConfigCollection, "globalConfig");
const getGlobalConfig = async ()=>{
    return (await getDoc(globalConfigDoc)).data();
};
function updateGlobalConfig(globalConfig, updates) {
    return (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .updateDoc */ .r7)(globalConfigDoc, updates);
}
function listenForGlobalConfig(setGlobalConfig) {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .listenForValue */ .y8)(globalConfigDoc, setGlobalConfig);
}


/***/ }),

/***/ 82989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GoToIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);

function GoToIcon(props) {
    const { className  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
        })
    });
}


/***/ }),

/***/ 79791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ActivitySection": function() { return /* binding */ ActivitySection; },
  "DailyMoversSection": function() { return /* binding */ DailyMoversSection; },
  "FeaturedSection": function() { return /* binding */ FeaturedSection; },
  "SearchSection": function() { return /* binding */ SearchSection; },
  "TrendingGroupsSection": function() { return /* binding */ TrendingGroupsSection; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; },
  "getHomeItems": function() { return /* binding */ getHomeItems; },
  "renderSections": function() { return /* binding */ renderSections; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(86677);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../node_modules/@heroicons/react/solid/PencilAltIcon.js
var PencilAltIcon = __webpack_require__(36308);
var PencilAltIcon_default = /*#__PURE__*/__webpack_require__.n(PencilAltIcon);
// EXTERNAL MODULE: ../node_modules/@heroicons/react/outline/PlusCircleIcon.js
var PlusCircleIcon = __webpack_require__(25011);
var PlusCircleIcon_default = /*#__PURE__*/__webpack_require__.n(PlusCircleIcon);
// EXTERNAL MODULE: ../node_modules/@heroicons/react/outline/XCircleIcon.js
var XCircleIcon = __webpack_require__(94689);
var XCircleIcon_default = /*#__PURE__*/__webpack_require__.n(XCircleIcon);
// EXTERNAL MODULE: ../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(38944);
// EXTERNAL MODULE: ../node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(93254);
// EXTERNAL MODULE: ../node_modules/lodash/difference.js
var difference = __webpack_require__(22346);
var difference_default = /*#__PURE__*/__webpack_require__.n(difference);
// EXTERNAL MODULE: ../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(95099);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ../node_modules/lodash/sum.js
var sum = __webpack_require__(79424);
var sum_default = /*#__PURE__*/__webpack_require__.n(sum);
// EXTERNAL MODULE: ../common/util/random.ts
var random = __webpack_require__(52506);
// EXTERNAL MODULE: ./components/layout/page.tsx + 10 modules
var page = __webpack_require__(25808);
// EXTERNAL MODULE: ./components/layout/col.tsx
var col = __webpack_require__(18264);
// EXTERNAL MODULE: ./hooks/use-tracking.ts
var use_tracking = __webpack_require__(5948);
// EXTERNAL MODULE: ./lib/service/analytics.ts + 37 modules
var analytics = __webpack_require__(62087);
// EXTERNAL MODULE: ./hooks/use-save-referral.ts
var use_save_referral = __webpack_require__(97543);
// EXTERNAL MODULE: ../common/group.ts
var common_group = __webpack_require__(63596);
// EXTERNAL MODULE: ./components/widgets/site-link.tsx
var site_link = __webpack_require__(67263);
// EXTERNAL MODULE: ./hooks/use-user.ts
var use_user = __webpack_require__(56314);
// EXTERNAL MODULE: ./hooks/use-group.ts
var use_group = __webpack_require__(8974);
// EXTERNAL MODULE: ./components/buttons/button.tsx
var buttons_button = __webpack_require__(84500);
// EXTERNAL MODULE: ./components/layout/row.tsx
var row = __webpack_require__(77990);
// EXTERNAL MODULE: ./components/contract/prob-change-table.tsx
var prob_change_table = __webpack_require__(85290);
// EXTERNAL MODULE: ./lib/firebase/groups.ts
var firebase_groups = __webpack_require__(88331);
// EXTERNAL MODULE: ./components/contract/contracts-grid.tsx
var contracts_grid = __webpack_require__(61364);
// EXTERNAL MODULE: ./components/buttons/pill-button.tsx
var pill_button = __webpack_require__(16865);
// EXTERNAL MODULE: ../common/util/array.ts
var array = __webpack_require__(15336);
// EXTERNAL MODULE: ./lib/firebase/users.ts
var users = __webpack_require__(63130);
// EXTERNAL MODULE: ../node_modules/lodash/isArray.js
var isArray = __webpack_require__(19785);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
// EXTERNAL MODULE: ../node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(83864);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);
// EXTERNAL MODULE: ./hooks/use-contracts.ts
var use_contracts = __webpack_require__(88176);
// EXTERNAL MODULE: ./components/widgets/loading-indicator.tsx
var loading_indicator = __webpack_require__(33794);
// EXTERNAL MODULE: ./components/widgets/input.tsx
var input = __webpack_require__(93440);
// EXTERNAL MODULE: ./components/groups/group-about.tsx + 4 modules
var group_about = __webpack_require__(63673);
// EXTERNAL MODULE: ./lib/firebase/globalConfig.ts
var firebase_globalConfig = __webpack_require__(18069);
// EXTERNAL MODULE: ./lib/firebase/posts.ts
var firebase_posts = __webpack_require__(97194);
// EXTERNAL MODULE: ./components/posts/post-card.tsx
var post_card = __webpack_require__(89157);
// EXTERNAL MODULE: ./lib/firebase/contracts.ts
var contracts = __webpack_require__(90742);
// EXTERNAL MODULE: ./components/contract/contract-card.tsx
var contract_card = __webpack_require__(63953);
// EXTERNAL MODULE: ./hooks/use-post.ts
var use_post = __webpack_require__(5264);
// EXTERNAL MODULE: ./hooks/use-global-config.ts
var use_global_config = __webpack_require__(30339);
// EXTERNAL MODULE: ./hooks/use-admin.ts
var use_admin = __webpack_require__(33880);
// EXTERNAL MODULE: ./hooks/use-persistent-state.ts
var use_persistent_state = __webpack_require__(52951);
// EXTERNAL MODULE: ./components/activity-log.tsx
var activity_log = __webpack_require__(53663);
// EXTERNAL MODULE: ./hooks/use-redirect-if-signed-out.tsx
var use_redirect_if_signed_out = __webpack_require__(17541);
// EXTERNAL MODULE: ./lib/icons/go-to-icon.tsx
var go_to_icon = __webpack_require__(82989);
// EXTERNAL MODULE: ./components/daily-stats.tsx
var daily_stats = __webpack_require__(32047);
;// CONCATENATED MODULE: ./lib/icons/home-settings-icon.tsx
// Icon from Bootstrap: https://icons.getbootstrap.com/

function HomeSettingsIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        fill: "currentColor",
        className: props.className,
        viewBox: "0 0 18 18",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.24,16.04s-.02,.02-.03,.03c.01,0,.01-.02,.02-.03h.01Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.03,8.89c-.12,.1-.22,.22-.3,.35l-.52,.9c-.06,.13-.1,.25-.13,.36-.02,.12-.03,.23-.03,.31,0,.22,.05,.43,.18,.67,0,.01,.01,.01,.01,.02h-.68c-.39,0-.7,.3-.7,.66v3.68c0,.36-.32,.66-.71,.66H3.69c-.62,0-1.12-.47-1.12-1.04v-6.82L7.75,4.5l1.25-1,1.25,1,3.13,2.5h-.87c-.11,0-.21,.03-.32,.06-.23,.08-.44,.21-.61,.41-.1,.12-.18,.24-.25,.44-.03,.08-.05,.17-.05,.19-.02,.09-.03,.17-.03,.25-.11,.05-.2,.1-.28,.15-.04,.02-.07,.04-.11,.06-.1,.04-.2,.09-.28,.17-.08-.04-.17-.08-.2-.09l-.16-.05c-.07,0-.23-.03-.31-.03-.14,0-.27,.02-.39,.06-.04,0-.08,.02-.11,.04-.03,0-.06,.02-.09,.03"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.5,8.04c-.16,0-.31-.07-.42-.2-.18-.23-.15-.57,.08-.75L8.68,1.08c.2-.16,.47-.16,.67,0l7.49,6c.23,.18,.27,.52,.08,.75-.19,.23-.52,.27-.75,.08L9.01,2.19,1.83,7.92c-.1,.08-.22,.12-.33,.12Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.19,13.88s0-.04-.01-.05c0-.02,0-.03-.01-.04,0-.01,0-.03-.01-.03,0-.03-.02-.05-.04-.07-.01,0-.04-.04-.06-.06-.02,0-.03-.02-.04-.03l-.44-.25s-.03-.03-.05-.05c-.05-.04-.08-.1-.08-.17l.08-.49v-.16s.01-.03,0-.05c.01-.08,0-.16,0-.23v-.02c0-.07,0-.11-.01-.17l-.07-.43c0-.07,.03-.12,.06-.17l.53-.31s.08-.07,.11-.14c.01,0,.03-.06,.03-.09,.01-.04,.01-.09,0-.13v-.02l-.04-.1-.54-.92-.03-.04s-.03-.04-.05-.05c-.02,0-.04-.02-.06-.03-.04-.02-.08-.03-.13-.03l-.11,.02-.51,.28s-.04,.02-.07,.03c-.04,.01-.09,.01-.13,0-.02,0-.04-.01-.05-.01l-.03-.02-.02-.02-.13-.1s-.04-.04-.06-.06c-.04-.03-.08-.06-.13-.1-.08-.06-.17-.11-.26-.17-.06-.03-.12-.06-.18-.09-.02,0-.05-.02-.08-.04-.02,0-.05-.02-.07-.03-.05-.02-.11-.05-.16-.07-.06-.01-.12-.03-.18-.05h0c-.08-.05-.14-.1-.16-.18h0s-.01-.05-.01-.06v-.5s-.01-.08-.03-.15c-.01-.02-.02-.04-.03-.06s-.03-.04-.05-.05c-.02,0-.04-.03-.05-.04-.01,0-.03-.02-.04-.03-.02-.01-.05-.02-.08-.03-.03,0-.05,0-.08,0h-1.12s-.07,.04-.09,.05c-.02,.01-.04,.03-.06,.06t-.03,.03s-.03,.04-.05,.07h0s-.02,.07-.02,.1c-.01,0-.01,.03-.01,.04v.52c0,.1-.06,.18-.15,.22l-.36,.14c-.1,.04-.2,.1-.29,.15l-.04,.02c-.06,.03-.12,.07-.17,.1-.01,0-.01,0-.02,0-.01,.01-.03,.02-.04,.03t-.01,.02s-.03,0-.04,.02h0s-.04,.03-.06,.05c-.05,.04-.08,.06-.12,.09l-.12,.1h-.01c-.06,.06-.14,.08-.22,.06l-.06-.03-.5-.27s-.02-.01-.03-.01c-.02,0-.03,0-.04,0-.02,0-.04,0-.05,0l-.1,.02h-.01s-.03,0-.04,0c-.02,.02-.04,.02-.06,.04-.04,.03-.08,.06-.1,.1l-.44,.77-.07,.13c-.04,.06-.04,.13-.04,.18s.01,.11,.05,.18l.04,.06s.07,.05,.09,.07l.15,.09,.33,.19,.1,.05-.02,.13-.04,.21c-.03,.2-.05,.38-.05,.57,0,.18,.02,.36,.05,.55l.04,.21s-.01,0-.01,.02c0,.08-.04,.16-.12,.21l-.51,.31h0s-.02,.04-.02,.04l-.06,.09h0s-.02,.08-.02,.11c0,.07,.02,.13,.05,.19,.01,0,.01,.01,.01,.01l.13,.24,.38,.64s.08,.09,.13,.13c.01,0,.02,.01,.03,.01,.1,.04,.22,.04,.32-.01l.44-.26s.04-.02,.06-.02c.02-.01,.04-.01,.06-.01,.03,0,.06,.01,.1,.02l.03,.02,.04,.03,.13,.11c.14,.11,.22,.17,.27,.2,.02,0,.03,0,.04,0l.03,.03,.06,.04s.06,.03,.13,.07c.1,.06,.2,.1,.29,.14,.01,0,.01,0,.02,0h.01s.27,.11,.27,.11c.04,.01,.08,.03,.11,.06,.03,.04,.05,.07,.06,.12,.01,.02,.01,.03,.01,.06v.54s.01,.02,.01,.02c-.01,.02,0,.03,0,.04,.01,.03,.03,.06,.04,.09,.01,0,.02,.02,.03,.04l.08,.07s.05,.03,.08,.04c.06,.02,.08,.02,.1,.02h1.06s.06,0,.09-.02c.03,0,.06-.02,.08-.03t.01-.01s.04-.03,.06-.05l.04-.05,.05-.13v-.04s.01-.59,.01-.59c.03-.08,.08-.14,.16-.17l.14-.05s.05-.02,.08-.03c0,0,.02-.01,.03-.02h.01s.05-.02,.07-.04c.01,.01,.02,0,.03,0,.05-.02,.1-.05,.15-.07,.01,0,.01-.01,.02-.01l.09-.05c.09-.05,.13-.08,.16-.1,.02,0,.04-.02,.06-.04,.05-.03,.09-.05,.13-.08,.03-.02,.06-.04,.09-.06,.01,0,.01-.02,.02-.03h.02s.03-.03,.04-.04l.13-.11h.01c.06-.06,.14-.08,.22-.06l.5,.28s.05,.03,.07,.02h.02s.05,.03,.07,.03h.04s0-.01,0-.01c.03,0,.07,0,.1-.02,.04,0,.07-.04,.12-.08,0,0,.04-.05,.06-.08,0,0,0,0,.02-.04l.11-.19c.15-.25,.36-.62,.39-.67h0s.03-.09,.03-.11c.01-.03,.01-.06,.01-.07h-.01Zm-4.07,.49c-.97,0-1.79-.7-1.98-1.61-.03-.13-.04-.27-.04-.41s0-.28,.04-.41c.19-.92,1.01-1.62,1.98-1.62,.13,0,.26,0,.38,.04,.12,.02,.23,.05,.34,.1h.02c.22,.09,.43,.21,.6,.37,.11,.09,.2,.2,.28,.31,.05,.05,.09,.1,.11,.16,.19,.31,.3,.66,.3,1.05,0,1.11-.91,2.02-2.03,2.02Z"
            })
        ]
    });
}

// EXTERNAL MODULE: ./pages/groups.tsx
var pages_groups = __webpack_require__(77130);
// EXTERNAL MODULE: ../common/envs/constants.ts + 2 modules
var constants = __webpack_require__(58756);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../common/util/time.ts
var time = __webpack_require__(95414);
// EXTERNAL MODULE: ./components/widgets/visibility-observer.tsx
var visibility_observer = __webpack_require__(55285);
;// CONCATENATED MODULE: ./pages/home/index.tsx






















































var __N_SSG = true;
function Home(props) {
    const user = (0,use_user/* useUser */.aF)();
    const privateUser = (0,use_user/* usePrivateUser */.MZ)();
    const followedGroupIds = (0,use_group/* useMemberGroupsIdsAndSlugs */._Z)(user);
    const shouldFilterDestiny = !(followedGroupIds === null || followedGroupIds === void 0 ? void 0 : followedGroupIds.find((g)=>constants/* DESTINY_GROUP_SLUGS.includes */.Ps.includes(g.slug)));
    const userBlockFacetFilters = (0,react.useMemo)(()=>{
        if (!privateUser) return undefined;
        var ref;
        const followedGroupSlugs = (ref = followedGroupIds === null || followedGroupIds === void 0 ? void 0 : followedGroupIds.map((g)=>g.slug)) !== null && ref !== void 0 ? ref : [];
        const destinyFilters = shouldFilterDestiny ? constants/* DESTINY_GROUP_SLUGS.map */.Ps.map((slug)=>"groupSlugs:-".concat(slug)) : [];
        const homeBlockedFilters = difference_default()(constants/* HOME_BLOCKED_GROUP_SLUGS */.Kf, followedGroupSlugs).map((slug)=>"groupSlugs:-".concat(slug));
        return (0,array/* buildArray */.f6)((0,users/* getUsersBlockFacetFilters */.mu)(privateUser), destinyFilters, homeBlockedFilters);
    }, [
        privateUser,
        followedGroupIds,
        shouldFilterDestiny
    ]);
    const isAdmin = (0,use_admin/* useAdmin */.A)();
    var ref;
    const globalConfig = (ref = (0,use_global_config/* useGlobalConfig */.W)()) !== null && ref !== void 0 ? ref : props.globalConfig;
    (0,use_redirect_if_signed_out/* useRedirectIfSignedOut */.V)();
    (0,use_tracking/* useTracking */.r)("view home");
    (0,use_save_referral/* useSaveReferral */.q)();
    var ref1;
    const { sections  } = getHomeItems((ref1 = user === null || user === void 0 ? void 0 : user.homeSections) !== null && ref1 !== void 0 ? ref1 : []);
    (0,react.useEffect)(()=>{
        if (user && !user.homeSections && sections.length > 0) {
            // Save initial home sections.
            (0,users/* updateUser */.Nq)(user.id, {
                homeSections: sections.map((s)=>s.id)
            });
        }
    }, [
        user,
        sections
    ]);
    const trending = (0,use_contracts/* useTrendingContracts */.AQ)(12, userBlockFacetFilters, !!userBlockFacetFilters);
    // Change seed every 15 minutes.
    const seed = Math.round(Date.now() / (15 * time/* MINUTE_MS */.g4)).toString();
    const trendingContracts = trending ? (0,random/* chooseRandomSubset */.ZM)(trending, 6, seed) : undefined;
    const newContracts = (0,use_contracts/* useNewContracts */.A_)(6, userBlockFacetFilters, !!userBlockFacetFilters);
    const dailyTrendingContracts = (0,use_contracts/* useContractsByDailyScore */.J5)(6, userBlockFacetFilters, !!userBlockFacetFilters);
    const contractMetricsByProfit = (0,use_user/* useUserContractMetricsByProfit */.jz)(user === null || user === void 0 ? void 0 : user.id);
    const [pinned, setPinned] = (0,use_persistent_state/* usePersistentState */.Yw)(null, {
        store: (0,use_persistent_state/* inMemoryStore */.cF)(),
        key: "home-pinned"
    });
    (0,react.useEffect)(()=>{
        const pinnedItems = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.pinnedItems;
        const userIsBlocked = (userId)=>{
            return (privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedUserIds.includes(userId)) || (privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedByUserIds.includes(userId));
        };
        if (pinnedItems) {
            const itemComponents = pinnedItems.map((element)=>{
                if ((element === null || element === void 0 ? void 0 : element.type) === "post") {
                    const post = element.item;
                    if (!userIsBlocked(post.creatorId)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(post_card/* PostCard */.y, {
                        post: post,
                        pinned: true
                    });
                } else if ((element === null || element === void 0 ? void 0 : element.type) == "group") {
                    const group = element.item;
                    if (!userIsBlocked(group.creatorId)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_groups.GroupCard, {
                        group: group,
                        pinned: true
                    });
                } else if ((element === null || element === void 0 ? void 0 : element.type) === "contract") {
                    const contract = element.item;
                    if (!userIsBlocked(contract.creatorId) && !(privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedContractIds.includes(contract.id)) && !(privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedGroupSlugs.some((slug)=>{
                        var ref;
                        return (ref = contract.groupSlugs) === null || ref === void 0 ? void 0 : ref.includes(slug);
                    }))) return /*#__PURE__*/ (0,jsx_runtime.jsx)(contract_card/* ContractCard */.C0, {
                        contract: contract,
                        pinned: true
                    });
                }
            });
            setPinned(itemComponents.filter((element)=>element != undefined));
        }
    }, [
        globalConfig,
        privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedByUserIds,
        privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedContractIds,
        privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedGroupSlugs,
        privateUser === null || privateUser === void 0 ? void 0 : privateUser.blockedUserIds,
        setPinned
    ]);
    const isLoading = !user || !privateUser || !trendingContracts || !newContracts || !dailyTrendingContracts || !globalConfig || !pinned;
    const [hasViewedBottom, setHasViewedBottom] = (0,use_persistent_state/* usePersistentState */.Yw)(false, {
        key: "has-viewed-bottom",
        store: (0,use_persistent_state/* inMemoryStore */.cF)()
    });
    var ref2;
    const groupContracts = (ref2 = (0,use_contracts/* useContractsByDailyScoreGroups */.uy)(followedGroupIds === null || followedGroupIds === void 0 ? void 0 : followedGroupIds.map((g)=>g.slug), 4, userBlockFacetFilters, !!userBlockFacetFilters)) !== null && ref2 !== void 0 ? ref2 : {};
    var ref3;
    const groups = (0,array/* filterDefined */.d0)((0,use_group/* useGroups */.XY)((ref3 = followedGroupIds === null || followedGroupIds === void 0 ? void 0 : followedGroupIds.map((g)=>g.id)) !== null && ref3 !== void 0 ? ref3 : []));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page/* Page */.T, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* Col */.J, {
                className: "pm:mx-10 gap-4 px-4 pb-8 pt-4 sm:pt-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* Row */.X, {
                        className: "mb-2 w-full items-center justify-between gap-2 sm:gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* Row */.X, {
                                className: "md:w-3/4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                        type: "text",
                                        placeholder: "Search Manifold",
                                        className: "w-full",
                                        onClick: ()=>router_default().push("/search"),
                                        onChange: (e)=>router_default().push("/search?q=".concat(e.target.value))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizeButton, {
                                        className: "ml-1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(daily_stats/* DailyStats */.L, {
                                user: user
                            })
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_indicator/* LoadingIndicator */.T, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            renderSections(sections, {
                                score: trendingContracts,
                                newest: newContracts,
                                "daily-trending": dailyTrendingContracts
                            }, isAdmin, globalConfig, pinned, contractMetricsByProfit),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(visibility_observer/* VisibilityObserver */.Z, {
                                className: "relative -top-[300px] h-1",
                                onVisibilityUpdated: (visible)=>visible && setHasViewedBottom(true)
                            }),
                            hasViewedBottom ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupSections, {
                                user: user,
                                groups: groups,
                                groupContracts: groupContracts
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_indicator/* LoadingIndicator */.T, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "fixed bottom-[70px] right-3 z-20 inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-4 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 lg:hidden",
                onClick: ()=>{
                    router_default().push("/create");
                    (0,analytics/* track */.j)("mobile create button");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((PencilAltIcon_default()), {
                    className: "h-7 w-7",
                    "aria-hidden": "true"
                })
            })
        ]
    });
}
const HOME_SECTIONS = [
    {
        label: "Trending",
        id: "score",
        icon: "\uD83D\uDD25"
    },
    {
        label: "Daily changed",
        id: "daily-trending",
        icon: "\uD83D\uDCC8"
    },
    {
        label: "Your daily movers",
        id: "daily-movers"
    },
    {
        label: "Featured",
        id: "featured",
        icon: "⭐"
    },
    {
        label: "New",
        id: "newest",
        icon: "✨"
    },
    {
        label: "Live feed",
        id: "live-feed",
        icon: "\uD83D\uDD34"
    }
];
const getHomeItems = (sections)=>{
    // Accommodate old home sections.
    if (!isArray_default()(sections)) sections = [];
    const itemsById = keyBy_default()(HOME_SECTIONS, "id");
    const sectionItems = (0,array/* filterDefined */.d0)(sections.map((id)=>itemsById[id]));
    // Add unmentioned items to the end.
    sectionItems.push(...HOME_SECTIONS.filter((item)=>!sectionItems.includes(item)));
    return {
        sections: sectionItems,
        itemsById
    };
};
function renderSections(sections, sectionContracts, isAdmin, globalConfig, pinned, dailyMovers) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: sections.map((s)=>{
            const { id , label , icon  } = s;
            if (id === "featured") return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedSection, {
                globalConfig: globalConfig,
                pinned: pinned,
                isAdmin: isAdmin
            }, "featured");
            if (id === "live-feed") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitySection, {}, id);
            if (id === "daily-movers") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DailyMoversSection, {
                    data: dailyMovers
                }, id);
            }
            const contracts = sectionContracts[id];
            if (id === "daily-trending") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSection, {
                    label: label,
                    contracts: contracts,
                    sort: "daily-score",
                    icon: icon
                }, id);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSection, {
                label: label,
                contracts: contracts,
                sort: id,
                icon: icon
            }, id);
        })
    });
}
const GroupSections = /*#__PURE__*/ (0,react.memo)(function GroupSections(props) {
    const { user , groups , groupContracts  } = props;
    const filteredGroups = groups.filter((g)=>groupContracts[g.slug]);
    const orderedGroups = sortBy_default()(filteredGroups, (g)=>// Sort by sum of top two daily scores.
        sum_default()(sortBy_default()(groupContracts[g.slug].map((c)=>c.dailyScore)).reverse().slice(0, 2))).reverse();
    const previouslySeenContracts = new Set();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: orderedGroups.map((group)=>{
            const contracts = groupContracts[group.slug].filter((c)=>Math.abs(c.probChanges.day) >= 0.01 && !previouslySeenContracts.has(c.id));
            if (contracts.length === 0) return null;
            contracts.forEach((c)=>previouslySeenContracts.add(c.id));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupSection, {
                group: group,
                user: user,
                contracts: contracts
            }, group.id);
        })
    });
});
function HomeSectionHeader(props) {
    const { label , href , children , icon  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* Row */.X, {
        className: (0,clsx_m/* default */.Z)("sticky top-0 z-20 my-1 -ml-1 items-center justify-between pb-2 pl-1 text-gray-900", constants/* BACKGROUND_COLOR */.Et),
        children: [
            icon != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mr-2 inline",
                children: icon
            }),
            href ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(site_link/* SiteLink */.J, {
                className: "flex-1 text-lg md:text-xl",
                href: href,
                onClick: ()=>(0,analytics/* track */.j)("home click section header", {
                        section: href
                    }),
                children: [
                    label,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(go_to_icon/* default */.Z, {
                        className: "mb-1 ml-2 inline h-5 w-5 text-gray-400"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1 text-lg md:text-xl",
                children: label
            }),
            children
        ]
    });
}
const SearchSection = /*#__PURE__*/ (0,react.memo)(function SearchSection(props) {
    const { label , contracts , sort , pill , icon  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* Col */.J, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeader, {
                label: label,
                href: "/search?s=".concat(sort).concat(pill ? "&p=".concat(pill) : ""),
                icon: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contracts_grid/* ContractsGrid */.M, {
                contracts: contracts,
                showImageOnTopContract: true
            })
        ]
    });
});
function FeaturedSection(props) {
    const { globalConfig , pinned , isAdmin  } = props;
    const posts = (0,use_post/* useAllPosts */.vu)();
    const groups = (0,use_group/* useTrendingGroups */.E2)();
    async function onSubmit(selectedItems) {
        if (globalConfig == null) return;
        const pinnedItems = await Promise.all(selectedItems.map(async (item)=>{
            if (item.type === "post") {
                const post = await (0,firebase_posts/* getPost */.xl)(item.itemId);
                if (post == null) return null;
                return {
                    item: post,
                    type: "post"
                };
            } else if (item.type === "contract") {
                const contract = await (0,contracts/* getContractFromId */.np)(item.itemId);
                if (contract == null) return null;
                return {
                    item: contract,
                    type: "contract"
                };
            } else if (item.type === "group") {
                const group = await (0,firebase_groups/* getGroup */.ex)(item.itemId);
                if (group == null) return null;
                return {
                    item: group,
                    type: "group"
                };
            }
        }).filter((item)=>item != null));
        var ref;
        await (0,firebase_globalConfig/* updateGlobalConfig */.Hl)(globalConfig, {
            pinnedItems: [
                ...(ref = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.pinnedItems) !== null && ref !== void 0 ? ref : [],
                ...pinnedItems
            ]
        });
    }
    function onDeleteClicked(index) {
        if (globalConfig == null) return;
        const newPinned = globalConfig.pinnedItems.filter((item)=>{
            return item.item.id !== globalConfig.pinnedItems[index].item.id;
        });
        (0,firebase_globalConfig/* updateGlobalConfig */.Hl)(globalConfig, {
            pinnedItems: newPinned
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* Col */.J, {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeader, {
                label: "Featured",
                icon: "⭐"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(group_about/* PinnedItems */.Ox, {
                posts: posts,
                isEditable: isAdmin,
                pinned: pinned,
                onDeleteClicked: onDeleteClicked,
                onSubmit: onSubmit,
                modalMessage: "Pin posts or markets to the overview of this group.",
                groups: groups
            })
        ]
    });
}
function GroupSection(props) {
    const { group , user , contracts  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* Col */.J, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeader, {
                label: group.name,
                href: (0,common_group/* groupPath */.E3)(group.slug),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_button/* Button */.zx, {
                    color: "gray-white",
                    onClick: ()=>{
                        var _homeSections;
                        const homeSections = ((_homeSections = user.homeSections) !== null && _homeSections !== void 0 ? _homeSections : []).filter((id)=>id !== group.id);
                        (0,users/* updateUser */.Nq)(user.id, {
                            homeSections
                        });
                        react_hot_toast_esm/* toast.promise */.Am.promise((0,firebase_groups/* leaveGroup */.Ln)(group, user.id), {
                            loading: "Unfollowing group...",
                            success: "Unfollowed ".concat(group.name),
                            error: "Couldn't unfollow group, try again?"
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((XCircleIcon_default()), {
                        className: "h-5 w-5 flex-shrink-0",
                        "aria-hidden": "true"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contracts_grid/* ContractsGrid */.M, {
                contracts: contracts.slice(0, 4),
                showImageOnTopContract: true
            })
        ]
    });
}
const DailyMoversSection = /*#__PURE__*/ (0,react.memo)(function DailyMoversSection(props) {
    const user = (0,use_user/* useUser */.aF)();
    const { data  } = props;
    if (!user || !data) return null;
    const { contracts , metrics  } = data;
    const hasProfit = metrics.some((m)=>m.from && m.from.day.profit > 0);
    const hasLoss = metrics.some((m)=>m.from && m.from.day.profit < 0);
    if (!hasProfit || !hasLoss) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* Col */.J, {
        className: "gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeader, {
                label: "Your daily movers",
                href: "/daily-movers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(prob_change_table/* ProfitChangeTable */.Dx, {
                contracts: contracts,
                metrics: metrics,
                maxRows: 3
            })
        ]
    });
});
const ActivitySection = /*#__PURE__*/ (0,react.memo)(function ActivitySection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* Col */.J, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeader, {
                label: "Live feed",
                href: "/live",
                icon: "\uD83D\uDD34"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(activity_log/* ActivityLog */.DA, {
                count: 6,
                showPills: true
            })
        ]
    });
});
const TrendingGroupsSection = /*#__PURE__*/ (0,react.memo)(function TrendingGroupsSection(props) {
    const { user , followedGroupIds , className  } = props;
    const trendingGroups = (0,use_group/* useTrendingGroups */.E2)();
    const myGroupIds = new Set(followedGroupIds.map((g)=>g.id));
    const groups = trendingGroups.filter((g)=>!myGroupIds.has(g.id));
    const count = 20;
    const chosenGroups = groups.slice(0, count);
    if (chosenGroups.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* Col */.J, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSectionHeader, {
                label: "Trending groups",
                href: "/explore-groups",
                icon: "\uD83D\uDC65"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 text-gray-500",
                children: "Follow groups you are interested in."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* Row */.X, {
                className: "flex-wrap gap-2",
                children: chosenGroups.map((g)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(pill_button/* PillButton */.T, {
                        className: "flex flex-row items-center gap-1",
                        selected: myGroupIds.has(g.id),
                        onSelect: ()=>{
                            if (myGroupIds.has(g.id)) (0,firebase_groups/* leaveGroup */.Ln)(g, user.id);
                            else {
                                var _homeSections;
                                const homeSections = ((_homeSections = user.homeSections) !== null && _homeSections !== void 0 ? _homeSections : []).filter((id)=>id !== g.id).concat(g.id);
                                (0,users/* updateUser */.Nq)(user.id, {
                                    homeSections
                                });
                                react_hot_toast_esm/* toast.promise */.Am.promise((0,firebase_groups/* joinGroup */.be)(g, user.id), {
                                    loading: "Following group...",
                                    success: "Followed ".concat(g.name),
                                    error: "Couldn't follow group, try again?"
                                });
                                (0,analytics/* track */.j)("home follow group", {
                                    group: g.slug
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((PlusCircleIcon_default()), {
                                className: "h-5 w-5 flex-shrink-0 text-gray-500",
                                "aria-hidden": "true"
                            }),
                            g.name
                        ]
                    }, g.id))
            })
        ]
    });
});
function CustomizeButton(props) {
    const { className  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        className: (0,clsx_m/* default */.Z)(className, (0,buttons_button/* buttonClass */.sP)("xs", "gray-white")),
        href: "/home/edit",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeSettingsIcon, {
            className: "h-7 w-7 text-gray-400",
            "aria-hidden": true
        })
    });
}


/***/ })

}]);